module.exports = __webpack_public_path__ + "a8e3cb97e1dbccf1f7d109ced133437d.jpg";